import { AdapterDateFnsJalali } from '@mui/x-date-pickers/AdapterDateFnsJalali';
import { faIR } from '@mui/x-date-pickers/locales';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import React from 'react';

const LocaleProvider = ({ children }) => (
	<LocalizationProvider
		dateAdapter={AdapterDateFnsJalali}
		localeText={faIR.components.MuiLocalizationProvider.defaultProps.localeText}
	>
		{children}
	</LocalizationProvider>
);

export default LocaleProvider;
